import * as React from 'react';
import { styled } from '@mui/system';
import { Divider } from '@mui/material';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import NotesCard from './components/NoteCard';
import LinkToListDialog from '../../../../components/shared/Dialog/LinkToListDialog';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';
import { DEFAULT_AVATAR } from '../../../../utils/constant';
import Loading from '../../../../components/ui/Loading';
import { extractIdFromURL } from '../../../../utils/common';
import { useGetUserProfileQuery } from '../../../../store/api/userApi';

const UserCardContainer = styled('div')(({ theme }) => ({
  background: 'transparent',
  padding: '15px',
  margin: '0 10px 0 10px',
  width: '400px',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('1000')]: {
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
  },
  [theme.breakpoints.down('750')]: {
    display: 'flex',
    flexDirection: 'column',
    width: '150px',
    margin: '0 40px 0 15px',
    padding: '2px',
  },
  [theme.breakpoints.down('650')]: {
    display: 'none',
  },
}));

const UserImage = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '1px',
  padding: '30px 30px 1px 65px',
  '& img': {
    borderRadius: '50%',
    width: '105px',
    height: '105px',
    objectFit: 'cover',
  },
  [theme.breakpoints.down('1000')]: {
    display: 'flex',
    flexDirection: 'column',

    padding: '10px 0px 100px 105px',
    '& img': {
      borderRadius: '50%',
      width: '85px',
      height: '85px',
      objectFit: 'cover',
    },
  },
  [theme.breakpoints.down('750')]: {
    display: 'flex',
    flexDirection: 'column',

    padding: '10px 0px 90px 65px',
    '& img': {
      borderRadius: '50%',
      width: '65px',
      height: '65px',
      objectFit: 'cover',
    },
  },
  [theme.breakpoints.down('650')]: {
    display: 'flex',
    flexDirection: 'column',

    padding: '10px 0px 85px 85px',
    '& img': {
      borderRadius: '50%',
      width: '63px',
      height: '63px',
      objectFit: 'cover',
    },
  },
}));

const UserName = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontFamily: 'Fjalla One',
  fontSize: '28px',
  padding: '20px 0px 0 200px',
  lineHeight: '5px',
  [theme.breakpoints.down('1000')]: {
    display: 'flex',
    marginLeft: '15px',
    fontFamily: 'Fjalla One',
    fontSize: '23px',
    padding: '20px 0px 0 105px',
    lineHeight: '2px',
  },
  [theme.breakpoints.down('750')]: {
    display: 'flex',
    marginLeft: '15px',
    fontFamily: 'Fjalla One',
    fontSize: '19px',
    padding: '7px 0px 0 65px',
    lineHeight: '1px',
  },
  [theme.breakpoints.down('650')]: {
    display: 'flex',
    marginLeft: '15px',
    fontFamily: 'Fjalla One',
    fontSize: '17px',
    padding: '7px 0px 0 85px',
    lineHeight: '1px',
  },
}));

const FollowDetail = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

const FollowItem = styled('div')(({ theme }) => ({
  display: 'flex',
  marginLeft: '200px',
  '& svg': {
    fontSize: '23px',
    color: '#AB9178',
  },
  [theme.breakpoints.down('1000')]: {
    display: 'flex',
    marginLeft: '95px',
    '& svg': {
      fontSize: '23px',
      color: '#AB9178',
    },
  },
  [theme.breakpoints.down('750')]: {
    display: 'flex',
    marginLeft: '50px',
    '& svg': {
      fontSize: '19px',
      color: '#AB9178',
    },
  },
  [theme.breakpoints.down('650')]: {
    display: 'flex',
    marginLeft: '70px',
    '& svg': {
      fontSize: '18px',
      color: '#AB9178',
    },
  },
}));

const Follower = styled('div')(() => ({
  display: 'flex',
  fontSize: '16px',
  fontfamily: 'Poppins',
  marginTop: '25px',
}));

const Following = styled('div')(() => ({
  display: 'flex',
  fontSize: '16px',
  fontfamily: 'Poppins',
  marginTop: '3px',
}));

const Number = styled('div')(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: 'bolder',
  padding: '0 3px 0 3px',
  color: 'black',
  fontSize: '16px',

  [theme.breakpoints.down('650')]: {
    fontFamily: 'Poppins',
    fontWeight: 'bolder',
    padding: '0 3px 0 3px',
    color: 'black',
    fontSize: '14px',
  },
}));

const NumberStyle = styled('div')(({ theme }) => ({
  fontSize: '16px',
  fontfamily: 'Poppins',
  [theme.breakpoints.down('650')]: {
    fontSize: '13px',
    fontfamily: 'Poppins',
  },
}));

const TitleDividerContainer = styled(Divider)(({ theme }) => ({
  paddingTop: '15px',

  '::before': {
    borderTop: '2px solid #AA9178',
    width: '190px',
  },

  '::after': {
    borderTop: '2px solid #AA9178',
    width: '190px',
  },

  '>span': {
    margin: '0px 2px 0px 2px',
    color: '#AA9178',
  },
  [theme.breakpoints.down('1000')]: {
    paddingLeft: '30px',

    '::before': {
      borderTop: '2px solid #AA9178',
      width: '150px',
    },

    '::after': {
      borderTop: '2px solid #AA9178',
      width: '150px',
    },

    '>span': {
      margin: '0px 2px 0px 2px',
      color: '#AA9178',
    },
  },
  [theme.breakpoints.down('750')]: {
    paddingLeft: '30px',

    '::before': {
      borderTop: '2px solid #AA9178',
      width: '110px',
      paddingLeft: '60px',
    },

    '::after': {
      borderTop: '2px solid #AA9178',
      width: '110px',
      paddingLeft: '60px',
    },

    '>span': {
      color: '#AA9178',
    },
  },
  [theme.breakpoints.down('650')]: {
    paddingLeft: '52px',

    '::before': {
      borderTop: '2px solid #AA9178',
      width: '180px',
      paddingLeft: '50px',
    },

    '::after': {
      borderTop: '2px solid #AA9178',
      width: '180px',
      paddingLeft: '50px',
    },

    '>span': {
      color: '#AA9178',
    },
  },
}));

const Title = styled('div')(({ theme }) => ({
  width: '100px',
  margin: '20px 0 0 155px',
  fontFamily: 'Fjalla One',
  fontWeight: '600',
  fontSize: '22px',
  lineHeight: '1px',
  [theme.breakpoints.down('1000')]: {
    margin: '20px 0 0 105px',
    fontSize: '22px',
  },
  [theme.breakpoints.down('750')]: {
    margin: '20px 0 0 80px',
    fontSize: '18px',
  },
  [theme.breakpoints.down('650')]: {
    margin: '20px 0 0 92px',
    fontSize: '16px',
  },
}));

const CardContainer = styled('div')(({ theme }) => ({
  maxWidth: '100%',
  marginTop: '40px',
  [theme.breakpoints.down('1000')]: {
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '60px',
  },
  [theme.breakpoints.down('750')]: {
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '80px',
    maxWidth: '40%',
  },
  [theme.breakpoints.down('650')]: {
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '110px',
    maxWidth: '10%',
  },
}));

const UserBroad = () => {
  const currentUserId = useSelector(selectUser);
  const id = extractIdFromURL(window.location.pathname)
    ? extractIdFromURL(window.location.pathname)
    : currentUserId;

  const { data: user, isLoading } = useGetUserProfileQuery(id);
  if (isLoading) return <Loading />;
  if (!user) return <Loading />;

  return (
    <UserCardContainer>
      {/* <Responsive> */}
      <UserImage>
        <img src={user.data.user.avatar || DEFAULT_AVATAR} alt=""></img>
      </UserImage>
      <UserName>{user.data.user.userName}</UserName>

      <FollowDetail>
        <FollowItem>
          <Follower>
            <LinkToListDialog
              title="followers"
              userList={user.data.user.followers}
            >
              <SentimentSatisfiedAltIcon />
              <Number> {user.data.user.followers.length}</Number>
              <NumberStyle>followers</NumberStyle>
            </LinkToListDialog>
          </Follower>
        </FollowItem>

        <FollowItem>
          <Following>
            <LinkToListDialog
              title="followering"
              userList={user.data.user.followings}
              currentUser={currentUserId}
            >
              <SupervisorAccountIcon />
              <Number>{user.data.user.followings.length}</Number>
              <NumberStyle>followering</NumberStyle>
            </LinkToListDialog>
          </Following>
        </FollowItem>
      </FollowDetail>
      {/* </Responsive> */}

      <TitleDividerContainer>♦</TitleDividerContainer>
      <Title>My Notes</Title>
      <CardContainer>
        <NotesCard noteCardData={user.data.user.postedNotes} />
      </CardContainer>
    </UserCardContainer>
  );
};

export default UserBroad;
